import * as config from '../config';
import InsecurePortalLogin from './InsecurePortalLogin';
import LoginFrame from './LoginFrame';
import MockLogin from './MockLogin';

const LoginComponent = {
  dynamics: InsecurePortalLogin,
  salesforce: LoginFrame,
  storybook: MockLogin,
}[config.EMBED];

if (!LoginComponent) {
  throw new TypeError(`Invalid value for REACT_APP_EMBED: ${config.EMBED}`);
}

export default LoginComponent;
